// FIXME: Remove usage of appeltaart <PZ 2019-12-18>

import throttle from 'lodash/throttle'
import { ready } from '../base/utils'

//
// Sticky Sidebar 2
// author: The Bohemian Carlos
//
// two ways of using it, just add a few data atrributes to the element:
//
// 'data-stick-sidebar' to define the Sidebar that will stick;
// 'data-sidebar-content=".selector"' as the target content area (needed for some measurements)
// 'data-sidebar-container=".selector"' as the parent element that both wraps the sidebar & content
//
// <nav data-sidebar data-sidebar-content=".selector" data-sidebar-container=".selector"></nav>
//
const StickySidebar = function ($e) {
  const $el = $e
  const $parent = $el.parentNode
  const $content = $el.find('.ss-content')[0]
  const offset = parseInt($el.attr('data-sticky-offset')) || 0
  const marginTop = parseInt(window.getComputedStyle($el).marginTop)
  let scrollTop = 0

  const getScrollTop = function () {
    return window.scrollY || (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
  }

  const getSidebarMaxHeight = function () {
    return window.innerHeight - offset
  }

  const getSidebarTop = function () {
    return $el.getBoundingClientRect().y + marginTop
  }

  const getSidebarBottom = function () {
    return $el.getBoundingClientRect().top + $el.getBoundingClientRect().height
  }

  const getParentTop = function () {
    return $parent.getBoundingClientRect().top + marginTop
  }

  const getParentBottom = function () {
    return $parent.getBoundingClientRect().top + $parent.getBoundingClientRect().height - window.innerHeight
  }

  //
  // "Set" methods
  //
  const stickSidebarToTop = function () {
    $el.addClass('ss-stick')
    $el.style.setProperty('margin-top', offset + 'px')
  }

  const resetStickSidebarToTop = function () {
    $el.removeClass('ss-stick')
    $el.style.setProperty('margin-top', '')
  }

  const stickSidebarToBottom = function () {
    $el.addClass('ss-stickup')
    $el.style.setProperty('bottom', 0)
  }

  const resetStickSidebarToBottom = function () {
    $el.removeClass('ss-stickup')
    $el.style.setProperty('bottom', '')
  }

  const setSidebarHeight = function () {
    let contentHeight = $content.offsetHeight
    const h = getSidebarMaxHeight()

    if (h > contentHeight) {
      contentHeight = 'auto'
      $el.removeClass('ss-resized')
    } else {
      contentHeight = h + 'px'
      $el.addClass('ss-resized')
    }
    $el.style.height = contentHeight
  }

  const resetSidebarHeight = function () {
    $el.removeClass('ss-resized')
    $el.style.height = 'auto'
  }

  const setSidebarWidth = function () {
    $el.style.width = $parent.offsetWidth + 'px'
  }

  const setSidebarLeft = function () {
    $el.style.left = $parent.getBoundingClientRect().left + 'px'
  }

  const resetSidebarLeft = function () {
    $el.style.left = 'auto'
  }

  const setSidebarPos = function () {
    const actScrollTop = getScrollTop()
    const scrollDelta = actScrollTop - scrollTop
    scrollTop = actScrollTop

    if (window.innerWidth >= 768) {
      resetSidebarHeight()
      setSidebarHeight()
      if (getParentTop() - offset < 0) {
        stickSidebarToTop()
      } else {
        resetStickSidebarToTop()
      }

      if (scrollDelta >= 0 && getParentBottom() < 0 && getSidebarBottom() > getParentBottom() + window.innerHeight) {
        stickSidebarToBottom()
      } else if (
        scrollDelta < 0 &&
        (getParentBottom() > 0 || getSidebarTop() - offset - marginTop > 0 || getParentTop() - offset >= 0)
      ) {
        resetStickSidebarToBottom()
      }

      if ($el.hasClass('ss-stick') && !$el.hasClass('ss-stickup')) {
        setSidebarLeft()
      } else {
        resetSidebarLeft()
      }
    } else {
      resetStickSidebarToBottom()
      resetStickSidebarToTop()
      resetSidebarHeight()
      resetSidebarLeft()
    }
  }

  const refreshSidebarLayout = function () {
    setSidebarWidth()
    setSidebarPos()
  }

  document.addEventListener('scroll', throttle(refreshSidebarLayout, 100))
  window.addEventListener('resize', throttle(refreshSidebarLayout, 100))

  refreshSidebarLayout()

  return $el
}

ready(() => {
  // init
  $$('.sticky-sidebar').each(function (idx, $el) {
    var stickySidebar = new StickySidebar($el)
    // scroll sidebar to the active elements
    var $selected = stickySidebar.querySelector('.active')
    var distanceFromTop = $selected ? $selected.offsetTop : false
    if (distanceFromTop && distanceFromTop > 350) {
      $el.querySelector('.ss-content').scrollTop = distanceFromTop - 250
    }
  })
})
